const en = {
  sectionTitle: 'Device Information',
  brandModel: 'Brand / Model',
  repairHistory: 'Repair History',
  loadingHistory: 'Loading history...',
  noRepairsYet: 'No repair tickets for this device yet',
  noCustomerOrDealer: 'No customer/dealer',
};

const de = {
  sectionTitle: 'Geräteinformationen',
  brandModel: 'Marke / Modell',
  repairHistory: 'Reparaturhistorie',
  loadingHistory: 'Historie wird geladen...',
  noRepairsYet: 'Noch keine Reparaturaufträge für dieses Gerät',
  noCustomerOrDealer: 'Kein Kunde/Händler',
};

const deviceDetails = { en, de };
export default deviceDetails;
